import { Injectable } from '@angular/core';
import * as AWS_UTIL from 'aws-sdk/browser';
import { BehaviorSubject, Observable } from 'rxjs';
import { TokenData } from './token.data';

/**
 * Token interface
 */
export interface Token {
    /**
     * Token
     */
    token: string;

    /**
     * Token data
     */
    data: TokenData;
}

/**
 * Token accessor service
 */
@Injectable()
export class TokenAccessorService {

    /**
     * Token observable
     */
    public tokenObservable: Observable<Token>;

    /**
     * Token subject to subscribe
     * @type {BehaviorSubject<any>}
     */
    private token: BehaviorSubject<Token> = new BehaviorSubject(null);

    /**
     * The "constructor"
     */
    constructor() {
        this.tokenObservable = this.token.asObservable().share();
    }

    /**
     * Get token
     * @returns {string}
     */
    public getToken(): string {
        return this.token.value ? this.token.value.token : null;
    }

    /**
     * Get token data
     * @returns {TokenData | null}
     */
    public getTokenData(): TokenData | null {
        return this.token.value ? this.token.value.data : null;
    }

    /**
     * Set token and token data
     * @param {string} token
     */
    public setToken(token: string): void {
        this.token.next({
            data: this.decodeToken(token),
            token
        });
    }

    /**
     * Clear token
     */
    public clear(): void {
        this.token.next(null);
    }

    /**
     * Decode token payload
     * @param {string} base64Text
     * @returns {object}
     */
    private decodePayload(base64Text: string): object {
        try {
            return JSON.parse(AWS_UTIL.util.base64.decode(base64Text).toString('utf8'));
        } catch (err) {
            return {};
        }
    }

    /**
     * Decode token
     * @param {string} idToken
     * @returns {TokenData}
     */
    private decodeToken(idToken: string): TokenData {
        if (!idToken) {
            return;
        }
        const jwtSplit = idToken.split('.');
        const payloadData: any = this.decodePayload(jwtSplit[1]);
        payloadData.userId = Array.isArray(payloadData.identities as any) ?
            payloadData.identities[0].userId : undefined;
        return payloadData as TokenData;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/security/token.accessor.service.ts